'use strict';

var $ = require('jquery');

module.exports = function hideControls() {
	$('.charting-pie-legend-editor').remove();
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/charting/charting-hide-controls.js
// module id = 102
// module chunks = 0